import { apiGetAppConfigs, apiUpdateAppConfig } from "@lib/api/settings";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useAppConfigQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || [
    "app-config",
    params ? JSON.stringify(params) : id,
  ];

  const appConfigsQuery = useQuery({
    queryFn: () => apiGetAppConfigs(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const updateAppConfigMutation = useMutation({
    mutationFn: apiUpdateAppConfig,
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.settings"] as string,
        ),
      );
      // queryClient.invalidateQueries({
      //   queryKey: queryKeys,
      // });
    },
  });

  return {
    appConfigsQuery,
    updateAppConfigMutation,
  };
};
